class info_tp2_algorithm_journal_edit_selectdialogsection extends Tango.Component {
	widgetDidMount() {
		var _this = this;
		
		document.querySelectorAll(".archdatareasoncaseicon").forEach(function (div) {
			const td = div.parentElement;
			const tr = td.parentElement;
			td.onclick = function () {
				document.getElementById("info_tp2_algorithm_journal_edit_archdatadiffreasoncase_id")?.setAttribute("value", tr.getAttribute("data-caseid"));
				document.getElementById("info_tp2_algorithm_journal_edit_algorithm_priority")?.setAttribute("value", tr.getAttribute("data-priority"));
			};
		});
		
		const reasonsTable = document.querySelector(".reasonsselect");
		if (!reasonsTable) return;

		reasonsTable.querySelectorAll("tr.reasonsselect-level1 a").forEach(function (expanderLink) {
			expanderLink.onclick = function (e) {
				e.preventDefault(); 

				const level1Row = this.closest("tr.reasonsselect-level1");
				if (!level1Row) return;

				const reasonId = level1Row.getAttribute("data-reasonid");
				const icon = this.querySelector("i"); 

				const isCollapsed = icon?.classList.contains('icon-collapsed');

				if (isCollapsed) {
					icon.classList.remove('icon-collapsed');
					icon.classList.add('icon-expanded');
					reasonsTable.querySelectorAll(`tr.reasonsselect-level2[data-reasonid='${reasonId}']`).forEach(el => {
						el.classList.remove('hide');
					});
				} else {
					icon.classList.add('icon-collapsed');
					icon.classList.remove('icon-expanded');
					reasonsTable.querySelectorAll(`tr.reasonsselect-level2[data-reasonid='${reasonId}']`).forEach(el => {
						el.classList.add('hide');
					});
				}
			};
		});
	}
}
Tango.registerComponent(info_tp2_algorithm_journal_edit_selectdialogsection, sp => ({
	cu: sp.commonUtils,
	au: sp.ajaxUtils,
	moment: moment,
	btnSwitchCtor: id => sp.components.btnswitch(id, sp)
}));